import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'
import { DatePicker } from 'hljd'
import moment from 'moment'
import React, { Component } from 'react'
import { FIELD_CONFIG } from '../../../constants'
import CheckInput from '../CheckInput'

const FormItem = Form.Item

class FormField extends Component {
  render() {
    const {
      propertyId,
      formItemLayout,
      form_default,
      getFieldDecorator,
      getFieldValue,
      getFieldError
    } = this.props
    if (propertyId && FIELD_CONFIG[propertyId]) {
      return FIELD_CONFIG[propertyId].map((item, index) => {
        const { title, type, placeholder, max, width } = item

        if (type == 'text') {
          const content = getFieldValue(title)
            ? getFieldValue(title)
            : form_default[title]
              ? form_default[title]
              : ''

          return (
            <FormItem label={title} {...formItemLayout} key={index}>
              {getFieldDecorator(title, {
                initialValue: form_default[title]
              })(
                <CheckInput
                  placeholder={placeholder}
                  style={{ width: width ? width : 440 }}
                  getFieldError={getFieldError}
                  maxLength={max ? max : undefined}
                  suffix={max ? `${content.length}/${max}` : ''}
                />
              )}
            </FormItem>
          )
        } else if (type == 'date') {
          return (
            <FormItem label={title} {...formItemLayout} key={index}>
              {getFieldDecorator(title, {
                initialValue: form_default[title]
                  ? moment(form_default[title])
                  : null
              })(
                <DatePicker style={{ width: 240 }} placeholder={placeholder} />
              )}
            </FormItem>
          )
        }
        return null
      })
    } else {
      return null
    }
  }
}

export default FormField
